var map = {
	"./15f27468-46a2-48a8-bc7a-fbe8b9f0a95f_m.png": "./src/assets/confetti/15f27468-46a2-48a8-bc7a-fbe8b9f0a95f_m.png",
	"./Jagermeister.png": "./src/assets/confetti/Jagermeister.png",
	"./mainProductPicture-ProductDetailsPage-ConversionMediaFormat-null.png": "./src/assets/confetti/mainProductPicture-ProductDetailsPage-ConversionMediaFormat-null.png",
	"./meme_(1).png": "./src/assets/confetti/meme_(1).png",
	"./shashlik.png": "./src/assets/confetti/shashlik.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/confetti sync \\.(png%7Cjpe?g%7Csvg)$";